<template>
  <b-row>
    <b-col md="6" sm="12">
      <div class="border p-2">
        <h4 class="text-center mb-3">Damage Reporting</h4>
        <b-form-file
          v-model="file"
          placeholder="select image"
          accept="image/jpg,image/png"
          @change="handleFileChange"/>
        <div class="d-flex">
          <label>Total indicated damages</label>&nbsp;
          <b-form-input v-model="value.totalIndicatedDamages" size="sm" style="width: 50%" type="number" min="0" />
        </div>
        <div class="font-weight-bold mb-1">Legend</div>
        <div class="text-center mb-3 d-flex justify-content-between">
          <div>
            <span class="text-danger font-weight-bold">RED</span>
            - Scratches
          </div>
          <div>
            <span class="text-primary font-weight-bold">BLUE</span>
            - Dents
          </div>
          <div>
            <span class="text-success font-weight-bold">GREEN</span>
            - Missing
          </div>
        </div>
        <img v-if="!useImagePlaceholder" :src="imagePreview" class="img-fluid">
        <img v-if="useImagePlaceholder" src="img/drc-template.png" class="img-fluid">
      </div>
    </b-col>
    <b-col md="6" sm="12">
      <div class="border p-2 h-100">
        <h4 class="text-center mb-3">Photo Damage Reporting</h4>
        <b-form-group label="Front section">
          <b-form-file
            v-model="damageReportPhoto.frontSection"
            placeholder="select image"
            accept="image/jpg,image/png"
            @change="handleFileChange"/>
        </b-form-group>
        <b-form-group label="Right-hand side (driver side) section">
          <b-form-file
            v-model="damageReportPhoto.rightHandSideSection"
            placeholder="select image"
            accept="image/jpg,image/png"
            @change="handleFileChange"/>
        </b-form-group>
        <b-form-group label="Left hand side section">
          <b-form-file
            v-model="damageReportPhoto.leftHandSideSection"
            placeholder="select image"
            accept="image/jpg,image/png"
            @change="handleFileChange"/>
        </b-form-group>
        <b-form-group label="Rear section">
          <b-form-file
            v-model="damageReportPhoto.rearSection"
            placeholder="select image"
            accept="image/jpg,image/png"
            @change="handleFileChange"/>
        </b-form-group>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import { toBase64 } from '@/utils/util'

export default {
  name: 'DamageForm',
  props: {
    value: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      file: null,
      imagePreview: '',
      useImagePlaceholder: false,
      damageReportPhoto: {
        frontSection: undefined,
        rightHandSideSection: undefined,
        lefHandSideSection: undefined,
        rearSection: undefined
      }
    }
  },
  watch: {
    value: {
      immediate: true,
      handler: function(nv) {
        if (nv && typeof nv.image === 'string') {
          this.imagePreview = nv.image
          this.value.image = undefined
        } else {
          this.useImagePlaceholder = true
        }
      }
    }
  },
  methods: {
    async handleFileChange (e) {
      this.useImagePlaceholder = false
      this.imagePreview = await toBase64(e.target.files[0])
      this.value.image = e.target.files[0]
    }
  }
}
</script>

<style>

</style>